import {CheckCircleFillIcon} from '@primer/octicons-react'
import {ReviewState, type CompletedReview} from '@github-ui/dotcom-schema/types/pull_requests/v1/review_requests'

import {ForYouItem} from '../shared/ForYouItem'
import {ForYouLeadingIcon} from '../shared/ForYouLeadingIcon'
import {useReviewData} from './use-review-data'

export function shouldShowReviewApproved(review: CompletedReview | null | undefined): review is CompletedReview {
  return review?.state === ReviewState.APPROVED
}

export function ReviewApproved({variant}: {variant?: 'default' | 'embedded'}) {
  const {data: review, queryStatus} = useReviewData()

  if (queryStatus !== 'success' || !shouldShowReviewApproved(review)) return null

  return (
    <ForYouItem
      leadingVisual={<ForYouLeadingIcon icon={CheckCircleFillIcon} variant="success" emphasized />}
      title="Approved"
      itemName="review-approved"
      variant={variant}
      description="You're all set — nothing to do."
      emphasizedLeadingVisual
    />
  )
}
